import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DataAccessUserPageFacade } from './state/page/data-access-user.page.facade';

@NgModule({
  imports: [CommonModule],
  providers: [DataAccessUserPageFacade],
})
export class Bau365DataAccessUserTrackingModule {}
